import styled from "styled-components";
import ExerciseInputField from "../../../../../basic/exerciseInputField/ExerciseInputField";
import DesignConstants from "../../../../../constants/DesignConstants";
import StyledButton from "../../../../../basic/styledButton/StyledButton";
import PhaseSixIcon from "../../../../../basic/phaseSixIcon/PhaseSixIcon";

export const SelectExerciseVocabularyHeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding-bottom: ${DesignConstants.SPACES.XS};

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        flex-direction: column;
        align-items: stretch;
        gap: ${DesignConstants.SPACES.S};
    }
`;

// Renders between the toggle button and the random-selector row.
// Desktop: parent `SelectExerciseVocabularyHeaderWrapper` has `flex-wrap: wrap`,
// so `flex-basis: 100%` forces this slot onto its own row (ordered after the
// toggle and before the selector via the `order: 1 / 10 / 20 / 30` ladder).
// Mobile: the parent flexes column, so `order` controls vertical position.
export const HeaderWarningSlot = styled.div`
    flex-basis: 100%;
    order: 10;
`;

export const ToggleSelectVocabularyButton = styled.button`
    display: flex;
    align-items: center;
    gap: ${DesignConstants.SPACES.XS};
    padding: ${DesignConstants.SPACES.XS};
    cursor: pointer;
    border: none;
    background: none;
    color: ${DesignConstants.COLORS.DARK_GREY};
    order: 1;

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        width: 100%;
        justify-content: flex-start;
    }
`;

export const StyledIcon = styled(PhaseSixIcon)`
    font-size: ${DesignConstants.FONT_SIZES.XXL};
`;

export const SelectExerciseVocabularyHeaderTitle = styled.p`
    font-size: ${DesignConstants.FONT_SIZES.L};
    font-weight: ${DesignConstants.FONT_WEIGHTS.SEMI_BOLD};
`;

export const RandomSelectionAndDeleteWrapper = styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    order: 20;

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        margin-left: unset;
        justify-content: flex-start;
    }
`;

export const RandomSelectionWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: right;

    &.hide {
        opacity: 0;
    }

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        width: 100%;
        justify-content: flex-start;
    }
`;

export const RandomCardNumberSelectorWrapper = styled.div`
    width: 70px;
    margin-right: 5px;

    > div {
        padding: 0;
    }
`;

export const StyledExerciseInputField = styled(ExerciseInputField)`
    width: 70px;
    height: 40px;
    flex: unset;
    margin: 0;
    background: white;
    border-radius: 100px 0 0 100px;
    border: ${DesignConstants.BORDERS.THIN} ${DesignConstants.COLORS.LIGHT_GREY};
    overflow: hidden;

    > div {
        padding: 0;
        background-color: ${DesignConstants.COLORS.P6_ORANGE};
    }

    > input {
        padding: 0 ${DesignConstants.SPACES.XS} 0 ${DesignConstants.SPACES.S};
        border: none;
    }

    &.disabled {
        opacity: ${DesignConstants.OPACITY.HALF};
        pointer-events: none;
        cursor: not-allowed;
    }
`;

export const StyledRandomSelectionButton = styled(StyledButton)`
    text-transform: capitalize !important;
    font-size: ${DesignConstants.FONT_SIZES.S};
    min-width: unset;
    min-height: 40px !important;
    padding: 0 ${DesignConstants.SPACES.S} !important;
    border: ${DesignConstants.BORDERS.THIN} ${DesignConstants.COLORS.LIGHT_GREY} !important;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        flex: 1;
    }
`;
